import React from 'react';

import { space } from './Spacer.module.scss';

export const Spacer = ({ withBorder = false }): JSX.Element => {
  if (withBorder) {
    return (
      <>
        <div className={space} />
        <hr />
        <div className={space} />
      </>
    );
  }
  return <div className={space} />;
};
